<template>
  <div>
    <div id="middleLine" v-if="false"></div> <!-- only show this if we need it -->
    <div class="container" v-if="!screenTooSmall">
      <div class="podium">
      </div>
      <div class="chart">
        <highcharts :options="chartOptions" />
      </div>
      <p v-for="elem in Object.keys(countryLabels)" :key="elem" v-show="showCountryLabels" @click="toggleCountryLabels"
        :id="elem" class="countrylabel">
        {{ countryLabels[elem] }}
      </p>
      <p id="countrytoggle" v-show="!showCountryLabels" @click="toggleCountryLabels">Show country labels</p>
      <div class="years_germany_right">
        <p class="normal">1775-1779</p>
        <p class="normal">1780-1784</p>
        <p class="normal">1785-1789</p>
        <p class="normal">1790-1794</p>
        <p class="normal">1795-1799</p>
        <p class="normal">1800-1804</p>
        <p class="normal">1805-1809</p>
        <p class="normal">1810-1814</p>
        <p class="normal">1815-1819</p>
        <p class="normal">1820-1824</p>
        <p class="normal">1825-1829</p>
        <p class="normal">1830-1834</p>
      </div>
      <div class="years_germany_left">
        <p class="normal">1775-1779</p>
        <p class="normal">1780-1784</p>
        <p class="normal">1785-1789</p>
        <p class="normal">1790-1794</p>
        <p class="normal">1795-1799</p>
        <p class="normal">1800-1804</p>
        <p class="normal">1805-1809</p>
        <p class="normal">1810-1814</p>
        <p class="normal">1815-1819</p>
        <p class="normal">1820-1824</p>
        <p class="normal">1825-1829</p>
        <p class="normal">1830-1834</p>
      </div>
      <div class="years_italy_left">
        <p class="rotated">1775-1779</p>
        <p class="rotated">1780-1784</p>
        <p class="rotated">1785-1789</p>
        <p class="rotated">1790-1794</p>
        <p class="rotated">1795-1799</p>
        <p class="rotated">1800-1804</p>
        <p class="rotated">1805-1809</p>
        <p class="rotated">1810-1814</p>
        <p class="rotated">1815-1819</p>
        <p class="rotated">1820-1824</p>
        <p class="rotated">1825-1829</p>
        <p class="rotated">1830-1834</p>
      </div>
      <div class="years_italy_right">
        <p class="rotated">1775-1779</p>
        <p class="rotated">1780-1784</p>
        <p class="rotated">1785-1789</p>
        <p class="rotated">1790-1794</p>
        <p class="rotated">1795-1799</p>
        <p class="rotated">1800-1804</p>
        <p class="rotated">1805-1809</p>
        <p class="rotated">1810-1814</p>
        <p class="rotated">1815-1819</p>
        <p class="rotated">1820-1824</p>
        <p class="rotated">1825-1829</p>
        <p class="rotated">1830-1834</p>
      </div>
      <div class="left_upper">
        <p class="upper">1775-1779</p>
        <p class="upper">1780-1784</p>
        <p class="upper">1785-1789</p>
        <p class="upper">1790-1794</p>
        <p class="upper">1795-1799</p>
        <p class="upper">1800-1804</p>
        <p class="upper">1805-1809</p>
        <p class="upper">1810-1814</p>
        <p class="upper">1815-1819</p>
        <p class="upper">1820-1824</p>
        <p class="upper">1825-1829</p>
        <p class="upper">1830-1834</p>
      </div>
      <div class="right_upper">
        <p class="upper">1775-1779</p>
        <p class="upper">1780-1784</p>
        <p class="upper">1785-1789</p>
        <p class="upper">1790-1794</p>
        <p class="upper">1795-1799</p>
        <p class="upper">1800-1804</p>
        <p class="upper">1805-1809</p>
        <p class="upper">1810-1814</p>
        <p class="upper">1815-1819</p>
        <p class="upper">1820-1824</p>
        <p class="upper">1825-1829</p>
        <p class="upper">1830-1834</p>
      </div>
    </div>
    <p v-else style="color:red; margin-top:5rem; font-size: large">
      Your screen width must be higher than {{ minWidth }}.
      <br>Please rotate your screen or enable desktop mode.
    </p>
  </div>
</template>

<script>
import seats from './seats.js';
let router;

export default {
  data() {
    return {
      windowWidth: window.innerWidth,
      minWidth: 800,

      finishedSeats: seats.map(obj => (
        {
          ...obj,
          name: this.$store.getters.getById(obj.id).title,
          composer: this.$store.getters.getById(obj.id).composer,
          librettist: this.$store.getters.getById(obj.id).librettist,
          year: this.$store.getters.getById(obj.id).performance_year,
          placename: this.$store.getters.getById(obj.id).placename,
          value: this.getColor(this.$store.getters.getById(obj.id).composer)
        }
      )),

      countryLabels: {
        germany: 'Germany',
        italy: 'Italy',
        austria: 'Austria',
        france: 'France',
        russia: 'Russia',
        malta: 'Malta',
        czech: 'Czech Republic',
        poland: 'Poland',
        england: 'England',
        netherlands: 'The Netherlands'
      },

      showCountryLabels: true,
    };
  },

  created() {
    router = this.$router;
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },

  computed: {
    // if true, don't display the chart
    screenTooSmall() {
      return this.windowWidth < this.minWidth;
    },

    chartOptions() {
      return {
        chart: {
          type: 'tilemap',
          inverted: true,
          height: '73%',
          marginTop: 100,
          backgroundColor: 'transparent'
        },

        accessibility: {
          description: 'A visualisation of the opera dataset delivered by the GD Contest.',
          point: {
            valueDescriptionFormat: '{xDescription}.'
          }
        },

        title: {
          text: 'Visualisation of the operas performed between 1775 and 1833 in Europe'
        },

        subtitle: {
          text: 'Source: <a href="http://mozart.diei.unipg.it/gdcontest/contest2022/topics.html">GD Contest (http://mozart.diei.unipg.it/gdcontest/contest2022)</a>'
        },

        tooltip: {
          headerFormat: '',
          pointFormat: '<b> {point.name} </b> ({point.placename}, {point.year}) was composed by <b>{point.composer}</b>. <br> The librettist was <b>{point.librettist}</b> -- Click for more info'
        },

        xAxis: {
          visible: false
        },

        yAxis: {
          visible: false
        },

        plotOptions: {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click: function () {
                  router.push(this.options.id.toString());
                }
              }
            }
          }
        },

        colorAxis: {
          dataClasses: [{
            from: 0,
            to: 0,
            color: '#FF0000',
            name: "Paisiello, Giovanni",
          }, {
            from: 1,
            to: 1,
            color: '#ffa500',
            name: 'Anfossi, Pasquale',
          }, {
            from: 2,
            to: 2,
            color: '#fde64b',
            name: 'Piccinni, Niccolò',
          }, {
            from: 3,
            to: 3,
            color: '#9A6324',
            name: 'Mozart, Wolfgang Amadeus',
          }, {
            from: 4,
            to: 4,
            color: '#3cb44b',
            name: 'Salieri, Antonio',
          }, {
            from: 5,
            to: 5,
            color: '#42d4f4',
            name: 'Martín y Soler, Vicente',
          }, {
            from: 6,
            to: 6,
            color: '#4363d8',
            name: 'Cimarosa, Domenico',
          }, {
            from: 7,
            to: 7,
            color: '#000000',
            name: 'Meyerbeer, Giacomo',
          }, {
            from: 8,
            to: 8,
            color: '#f032e6',
            name: 'Mayr, Johann Simon',
          }, {
            from: 9,
            to: 9,
            color: '#a9a9a9',
            name: 'Rossini, Gioachino',
          }]
        },

        series: [{
          name: '',
          data: this.finishedSeats
        }]
      }
    }
  },

  methods: {
    getColor(composer) {
      this.value = null;
      if (composer == "Paisiello, Giovanni") this.value = 0;
      else if (composer == "Anfossi, Pasquale") this.value = 1;
      else if (composer == "Piccinni, Niccolò") this.value = 2;
      else if (composer == 'Mozart, Wolfgang Amadeus') this.value = 3;
      else if (composer == 'Salieri, Antonio') this.value = 4;
      else if (composer == 'Martín y Soler, Vicente') this.value = 5;
      else if (composer == 'Cimarosa, Domenico') this.value = 6;
      else if (composer == 'Meyerbeer, Giacomo') this.value = 7;
      else if (composer == 'Mayr, Johann Simon') this.value = 8;
      else if (composer == "Rossini, Gioachino") this.value = 9;

      else this.value = 10

      return this.value
    },

    onResize() {
      this.windowWidth = window.innerWidth;
    },

    toggleCountryLabels() {
      this.showCountryLabels = !this.showCountryLabels;
    }
  }
}
</script>

<style scoped>
/* shows the middle of the page */
#middleLine {
  width: 0px;
  height: 100%;
  position: absolute;
  left: 50%;
  transform: translateX(-1px);
  border: 1px solid purple;
  z-index: 2;
}

.container {
  min-width: 360px;
  max-width: 750px;
  margin: 0 auto;
  position: relative;
}

.podium {
  height: 70px;
  width: 100%;
  background-color: #D3D3D3;
  position: absolute;
  opacity: 0.4;
  border: 3px solid;
  border-top: none;
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
  text-align: center;
}

.chart {
  position: absolute;
  z-index: 1;
  opacity: 1;
  margin: auto;
  width: 100%;
}

div.highcharts-container {
  margin: auto;
}

.years_germany_left {
  position: absolute;
  top: 103px;
  left: 233px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
}

.years_germany_right {
  position: absolute;
  top: 103px;
  left: 475px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
}

.years_italy_left {
  position: absolute;
  top: 287px;
  left: 194px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
  transform: rotate(18deg);
}

.years_italy_right {
  position: absolute;
  top: 287px;
  left: 516px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
  transform: rotate(-18deg);
}

.left_upper {
  position: absolute;
  top: 167px;
  left: 33px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
  transform: rotate(55deg);
}

.right_upper {
  position: absolute;
  top: 167px;
  left: 675px;
  z-index: 2;
  opacity: 0.5;
  font-size: 8px;
  transform: rotate(-55deg);
}

.normal {
  line-height: 5.7px;
  color: black;
}

.rotated {
  line-height: 5.3px;
  color: black;
}

.upper {
  line-height: 4.9px;
  color: black;
}

/* country labels */
p.countrylabel,
p#countrytoggle {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: rgba(96, 96, 96, 0.7);
  padding: 0.2rem;
  padding-top: 0.1rem;
  padding-bottom: 0.1rem;
  border-radius: 0.5rem;
  border: 2px solid rgba(128, 128, 128, 0.2);
  /* transform country labels to the middle of their position */
  transform: translate(-50%, -50%);
  z-index: 2;
  position: absolute;
}

p#countrytoggle {
  left: 14%;
  top: 85px;
  color: rgba(128, 128, 128, 0.8);
  border: 2px solid rgba(128, 128, 128, 0.4);
  letter-spacing: 1px;
}

p.countrylabel:hover,
p#countrytoggle:hover {
  cursor: pointer;
}

p#germany {
  left: 50%;
  top: 80px;
}

p#italy {
  left: 50%;
  top: 282px;
}

p#austria {
  left: 23.7%;
  top: 236px;
  transform: translate(-50%, -50%) rotate(37deg);
}

p#france {
  left: 14%;
  top: 146px;
  transform: translate(-50%, -50%) rotate(59deg);
}

p#russia {
  left: 73.8%;
  top: 245px;
  transform: translate(-50%, -50%) rotate(-32deg);
}

p#malta {
  left: 78.6%;
  top: 306px;
  transform: translate(-50%, -50%) rotate(-32deg);
}

p#czech {
  left: 82%;
  top: 245px;
  padding: 0;
  padding-bottom: 0;
  transform: translate(-50%, -50%) rotate(44deg);
  white-space: nowrap;
}

p#poland {
  left: 95%;
  top: 322px;
  transform: translate(-50%, -50%) rotate(13deg);
}

p#england {
  left: 91%;
  top: 174px;
  transform: translate(-50%, -50%) rotate(35deg);
}

p#netherlands {
  left: 95%;
  top: 150px;
  transform: translate(-50%, -50%) rotate(35deg);
}


span {
  font-size: 14px;
  font-weight: bold;
  color: black;
  vertical-align: middle;
}

caption {
  padding-bottom: 15px;
  font-family: Verdana, sans-serif;
  font-size: 1.2em;
  color: #555;
}

table {
  font-family: Verdana, sans-serif;
  font-size: 12pt;
  border-collapse: collapse;
  border: 1px solid #ebebeb;
  margin: 10px auto;
  text-align: center;
  width: 100%;
}

table tr:nth-child(odd) {
  background-color: #fff;
}

table tr:nth-child(even) {
  background-color: #fcf9f9;
}

th {
  font-weight: 600;
  padding: 10px;
}
</style>
